import { Component } from '@angular/core';
import { UpperCasePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '@env/environment';

interface LanguageOption {
  code: string;
  label: string;
}

export const LANGUAGE_STORAGE_KEY = 'language';

@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [NgbDropdownModule, UpperCasePipe],
  templateUrl: './language-switcher.component.html'
})
export class LanguageSwitcherComponent {

  languages: LanguageOption[] = [
    { code: 'de', label: 'Deutsch' },
    { code: 'en', label: 'English' },
    { code: 'it', label: 'Italiano' }
  ];

  constructor(private translate: TranslateService) { }

  get currentLanguage(): LanguageOption {
    const current = this.translate.currentLang || environment.defaultLanguage;
    return this.languages.find(l => l.code === current) ?? this.languages[0];
  }

  selectLanguage(code: string) {
    this.translate.use(code);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, code);
  }
}
